import { render, staticRenderFns } from "./ScadenzaFormDialog.vue?vue&type=template&id=080c2a3a&"
import script from "./ScadenzaFormDialog.vue?vue&type=script&lang=js&"
export * from "./ScadenzaFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports